module.exports = __webpack_public_path__ + "img/Paso 6.f7676e77.png";